// extracted by mini-css-extract-plugin
export default {"item":"TaskItem_item__naPR+","checkbox":"TaskItem_checkbox__MpauG"};